import { render, staticRenderFns } from "./IntegrationStore.vue?vue&type=template&id=5a8836ea&scoped=true&"
import script from "./IntegrationStore.vue?vue&type=script&lang=ts&"
export * from "./IntegrationStore.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationStore.vue?vue&type=style&index=0&id=5a8836ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8836ea",
  null
  
)

export default component.exports